import { Component } from "react";
import Kalp from "./Kalp";
import Creditsafe from "../../../users/credditsafe/Creditsafe.Component";

export default class CreditRep extends Component {
  render() {
    let style = {
      padding: "10px",
      float: "left",
    };
    return (
      <div className="row" style={style}>
        <div className="col-md-8">
          <Creditsafe
            report={this.props.application.CreditSafeReport}
            bisnodeReport={this.props.application.BisnodeReport}
          />
        </div>
        <div className="col-md-4">
          <Kalp application={this.props.application} />
        </div>
      </div>
    );
  }
}
